/* eslint-disable no-underscore-dangle */
import { useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { DELETE_CREDENTIALS_CLIQUE_RETIRE } from './graphql';

export function useDeleteCliqueRetireCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [DeleteCliqueRetireCredentials, { loading }] = useMutation(
    DELETE_CREDENTIALS_CLIQUE_RETIRE,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  async function deleteCliqueRetireCredentials(storeId) {
    try {
      const res = await DeleteCliqueRetireCredentials({
        variables: { storeId },
      });
      const { code, message } = res.data.deleteCliqueRetireCredentials;
      if (code === 200) {
        setSuccessMessage(message);
      } else {
        setErrorMessage(message);
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível deletar as credenciais CliqueRetire, tente novamente mais tarde.',
      );
    }
  }

  return {
    deleteCliqueRetireCredentials,
    loading,
  };
}
